import initState from "./initState";

import * as types from "./types";
import {
  updateObject,
  arrayToObject,
  deepCompare,
  deepClone,
  isDecodable,
  encodeHandler,
  sortArrayByKey
} from "utils";
import { HELPERS, CONTENT } from "consts";

function fetchFRRecoveryPointsSuccess(state, action) {
  if (!deepCompare(state.currentRequest, action.params.requestConfigParams))
    return state;

  let updatedRecoveryPoints = { ...state.recoveryPoints };

  if (action.points.length > 0) {
    updatedRecoveryPoints.current = action.points[0];
    sortCurrentVolumesByName(updatedRecoveryPoints);
    updatedRecoveryPoints.list = arrayToObject(action.points, "scheduleUUID");
  } else {
    updatedRecoveryPoints = initState.recoveryPoints;
  }

  return updateObject(state, {
    loading: false,
    transLoading: false,
    breadCrumbs: initState.breadCrumbs,
    recoveryPoints: updatedRecoveryPoints,
    files: {
      ...initState.files,
      loading: false
    }
  });
}

function fetchFRRecoveryPointsFailure(state, action) {
  return updateObject(state, {
    loading: false,
    failed: {
      msg: action.data.msg,
      status: action.data.status
    }
  });
}

function updateFRRecoveryPointSuccess(state, action) {
  const updatedRecoveryPoints = { ...state.recoveryPoints };
  updatedRecoveryPoints.current = action.points[0];
  updatedRecoveryPoints.list[action.points[0].scheduleUUID].volumes =
    action.points[0].volumes;
  sortCurrentVolumesByName(updatedRecoveryPoints);
  return updateObject(state, {
    loading: false,
    transLoading: false,
    breadCrumbs: initState.breadCrumbs,
    recoveryPoints: updatedRecoveryPoints,
    checkedList: []
  });
}

function changeFRRecoveryPoint(state, action) {
  const updatedCurrent = state.recoveryPoints.list[action.scheduleUUID];
  sortCurrentVolumesByName(updatedCurrent);
  return updateObject(state, {
    loading: false,
    breadCrumbs: initState.breadCrumbs,
    homeBreadCrumbPressed: true,
    recoveryPoints: updateObject(state.recoveryPoints, {
      current: updatedCurrent
    })
  });
}

function sortCurrentVolumesByName(recoveryPoints) {
  if (recoveryPoints?.current?.volumes?.length) {
    recoveryPoints.current.volumes = sortArrayByKey(
      recoveryPoints.current.volumes,
      "name"
    );
  }
}

function fetchFilesSuccess(state, action) {
  let currentRequestDummy = deepClone(state.currentRequest);
  let requestConfigParamsDummy = deepClone(action.params.requestConfigParams);
  delete currentRequestDummy.responseStatus;
  delete requestConfigParamsDummy.responseStatus;
  if (!deepCompare(currentRequestDummy, requestConfigParamsDummy)) return state;

  const updatedState = { ...state };

  const updatedFiles = { ...updatedState.files };
  const updatedCheckedList = [];

  const updatedBreadCrumbs = { ...updatedState.breadCrumbs };
  let updatedRelPath = [...updatedBreadCrumbs.relPath];
  const updatedFileList = action.params.requestConfigParams.offset
    ? state.files.list
    : {};

  updatedFiles.loading = false;
  updatedFiles.offsetLoading = false;
  //
  updatedBreadCrumbs.volume = action.params.volume;

  /*Checking if someone has pressed home button from breadcrumbs while calling fileListing api
  and bypassing that fileListing response and showing relevant screen to home....
   * */
  if (!updatedState?.homeBreadCrumbPressed) {
    // if (action.params.file) {
    const index = updatedRelPath.findIndex(
      val => val.fileId === action.params.file.fileId
    );
    if (index > -1 && action.params.type === "fetch") {
      updatedRelPath = updatedRelPath.slice(0, index + 1);
    } else if (index > -1 && action.params.type === "search") {
      updatedRelPath = updatedRelPath.slice(0, index + 1);

      if (
        (updatedRelPath.length === 0 ||
          updatedRelPath[updatedRelPath.length - 1].name !==
            HELPERS.slidingPopup.searchResult) &&
        action.params.file.searchActions.pattern !== ""
      ) {
        updatedRelPath.push({
          name: HELPERS.slidingPopup.searchResult,
          fileId: action.params.file.fileId,
          searchActions: { ...action.params.file.searchActions }
        });
      }
    } else {
      if (action.params.type === "fetch") {
        updatedRelPath.find(
          path => path.name === HELPERS.slidingPopup.searchResult
        ) && updatedRelPath.pop();
        if (action.params.file) {
          updatedRelPath.push({
            ...action.params.file,
            ...{ path: action.params.path }
          });
        } else {
          updatedRelPath.push({
            path: action.params.path,
            name:
              (action.params.volume.label
                ? action.params.volume.label
                : CONTENT.restore.file.volumesList) +
              " (" +
              action.params.volume.name +
              ":)"
          });
        }
      } else {
        updatedRelPath.push(action.params.file);
      }
    }
    //}
    // else updatedRelPath = [];

    if (action.params.type === "fetch") {
      updatedState.patternSearch = "";
      if (
        updatedRelPath.length !== 0 &&
        updatedRelPath[updatedRelPath.length - 1].name ===
          HELPERS.slidingPopup.searchResult
      )
        updatedRelPath.pop();
    }

    updatedBreadCrumbs.relPath = updatedRelPath;
    updatedState.breadCrumbs = updatedBreadCrumbs;

    // if (action.params.type === "fetch") {
    //   const decompressedData = decompressionAlgorithm(action.files);
    //   console.log("into fetch", decompressedData);
    //   decompressedData.map(
    //     val =>
    //       isDecodable(val.name, "Restore file name -") &&
    //       isDecodable(val.path, "Restore file path -") &&
    //       (updatedFileList[val.fileId] = {
    //         ...val,
    //         name: val.name,
    //         modifiedTime: val.modifiedTime,
    //         size: val.size,
    //         checked: false,
    //         priority: val.isDir ? 1 : 2,
    //         path: val.path
    //       })
    //   );
    // } else if (action.params.type === "search") {
    if (updatedState)
      action.files.map(
        val =>
          isDecodable(val.name, "Restore file name -") &&
          isDecodable(val.path, "Restore file path -") &&
          (updatedFileList[val.fileId] = {
            ...val,
            name: val.name,
            modifiedTime: val.modifiedTime,
            size: val.size,
            checked: false,
            priority: val.isDir ? 1 : 2,
            path: val.path
          })
      );

    updatedFiles.checked = false;
    /* updated semicheck key value */
    updatedFiles.semiChecked = false;
    updatedFiles.responseStatus = action.params.responseStatus;
    updatedFiles.type = action.params.type;

    if (action.params.type === "search") {
      updatedState.patternSearch = action.params.file.searchActions.pattern;
    }

    //if checked with concat and checkedlist
    if (action.params.concat && updatedState.checkedList?.length > 0) {
      updatedState.checkedList.map(val => {
        updatedFileList[val.fileId].checked = true;
      });

      // updatedFiles.semiChecked = true;
      updatedFiles.checked = true;
    } else {
      updatedState.checkedList = [];
    }

    updatedFiles.list = updatedFileList;
    updatedState.files = updatedFiles;
  } else {
    updatedFiles.list = updatedFileList;
    updatedState.files = updatedFiles;
  }

  for (let key in updatedState.files.list) {
    updatedState.files.list[key].checked = updatedState.files.checked;
    if (updatedState.files.checked)
      updatedCheckedList.push(updatedState.files.list[key]);
  }
  updatedState.checkedList = [...updatedCheckedList];

  return updatedState;
}

function fetchFilesFailure(state, action) {
  return updateObject(state, {
    files: updateObject(state.files, {
      loading: false
    })
  });
}

function toggleSelectAllFiles(state, action) {
  const updatedFilesObj = { ...state.files };
  const updatedCheckedList = [];

  updatedFilesObj.checked = !updatedFilesObj.checked;
  updatedFilesObj.semiChecked = false;

  for (let key in updatedFilesObj.list) {
    updatedFilesObj.list[key].checked = updatedFilesObj.checked;
    if (updatedFilesObj.checked)
      updatedCheckedList.push(updatedFilesObj.list[key]);
  }

  return updateObject(state, {
    files: updatedFilesObj,
    checkedList: updatedCheckedList
  });
}

function toggleFileSelection(state, action) {
  const updatedFilesObj = { ...state.files };
  const updatedCheckedList = [];

  updatedFilesObj.recentSelected = action.id;
  updatedFilesObj.list[action.id].checked = !updatedFilesObj.list[action.id]
    .checked;
  updatedFilesObj.checked = false;
  updatedFilesObj.semiChecked = false;

  for (let key in updatedFilesObj.list) {
    if (updatedFilesObj.list[key].checked) {
      updatedFilesObj.checked = true;
      updatedCheckedList.push(updatedFilesObj.list[key]);
    }
  }

  for (let key in updatedFilesObj.list) {
    if (!updatedFilesObj.list[key].checked && updatedFilesObj.checked) {
      updatedFilesObj.semiChecked = true;
    }
  }

  return updateObject(state, {
    files: updatedFilesObj,
    checkedList: updatedCheckedList
  });
}

function toggleShiftFileSelection(state, action) {
  const updatedFilesObj = { ...state.files };
  const updatedCheckedList = [];

  updatedFilesObj.list[action.id].checked = !updatedFilesObj.list[action.id]
    .checked;
  updatedFilesObj.checked = false;
  updatedFilesObj.semiChecked = false;

  let shiftSelect,
    selectId = null;
  const selectFileId = updatedFilesObj.recentSelected;
  action.filesList.forEach((v, i) => {
    if (v.fileId === action.id) {
      shiftSelect = i;
    }
    if (v.fileId === selectFileId) {
      selectId = i;
    }
    if (!selectId) selectId = 0;
  });

  const updatedFileArray = action.filesList.map((v, i) => {
    if (i === selectId || i === shiftSelect) {
      v.checked = true;
      return v;
    } else if (i > selectId && i < shiftSelect) {
      v.checked = true;
      return v;
    } else if (i > shiftSelect && i < selectId) {
      v.checked = true;
      return v;
    } else if (v.checked === true) {
      return v;
    } else {
      v.checked = false;
      return v;
    }
  });

  updatedFilesObj.list = arrayToObject(updatedFileArray, "fileId");

  for (let key in updatedFilesObj.list) {
    if (updatedFilesObj.list[key].checked) {
      updatedFilesObj.checked = true;
      updatedCheckedList.push(updatedFilesObj.list[key]);
    }
  }

  for (let key in updatedFilesObj.list) {
    if (!updatedFilesObj.list[key].checked && updatedFilesObj.checked) {
      updatedFilesObj.semiChecked = true;
    }
  }

  return updateObject(state, {
    files: updatedFilesObj,
    checkedList: updatedCheckedList
  });
}

function fetchFilesStart(state, action) {
  return updateObject(state, {
    homeBreadCrumbPressed: false,
    files: updateObject(state.files, {
      loading: action.params.offset ? false : true,
      offsetLoading: action.params.offset ? true : false
    })
  });
}

function patternSearchStart(state, action) {
  return updateObject(state, {
    files: updateObject(state.files, {
      loading: true
    })
  });
}

function fetchFRRecoveryPointsStart(state, action) {
  return updateObject(state, {
    loading: action.params.onMount ? true : false,
    transLoading: action.params.onMount ? false : true
  });
}

function changeSearch(state, action) {
  return updateObject(state, {
    patternSearch: action.searchPattern,
    files: updateObject(state.files, {
      loading: action.loading
    })
  });
}

function storeRestoreParams(state, action) {
  let currentObject = action.params;
  return updateObject(state, {
    currentRequest: currentObject
  });
}

function clearFileRestore() {
  return initState;
}

function downloadRestoreFilesStart(state, action) {
  const updatedFiles = { ...state.files };
  if (updatedFiles.localDownload) {
    updatedFiles.localDownload.push(action.params.fileIds[0]);
  } else {
    updatedFiles.localDownload = [action.params.fileIds[0]];
  }
  return updateObject(state, {
    files: updatedFiles
  });
}

function removeRestoreURLLoader(state, action) {
  const updatedFiles = { ...state.files };

  if (updatedFiles.localDownload.length === 1) {
    delete updatedFiles.localDownload;
  } else {
    let index = updatedFiles.localDownload.indexOf(action.fileId);
    if (index !== -1) updatedFiles.localDownload.splice(index, 1);
  }

  return updateObject(state, {
    files: updatedFiles
  });
}

function populateUpdatedVolumesFR(state, action) {
  const updatedVolumesResponse =
    state.currentRequest &&
    state.targetMachine &&
    state.targetMachine.clientUUID === action.client.clientUUID
      ? action.client.volumes.map(vol => {
          vol.selected = false;
          return vol;
        })
      : state.updatedVolumes;

  return updateObject(state, {
    updatedVolumes: updatedVolumesResponse,
    requestedUpdatedVolumes: false,
    files: updateObject(state.files, {
      loading: false
    })
  });
}

function fetchUpdatedVolumesFR(state, action) {
  return updateObject(state, {
    requestedUpdatedVolumes: true,
    files: updateObject(state.files, {
      loading: true
    })
  });
}

function setDisableRestore(state, action) {
  return updateObject(state, {
    disableRestore: action.bool
  });
}

function enumFolderResponse(state, action) {
  if (state.clientUUID !== action.clientUUID) return state;

  const updatedEnumFolder = deepClone(state.enumFolder);

  let updatedBreadCrumbs = state.enumFolder.breadCrumbs
    ? [...state.enumFolder.breadCrumbs]
    : [];

  if (action.data.path) {
    let index;
    updatedBreadCrumbs.forEach((crumb, i) => {
      if (crumb.path === action.data.path) {
        index = i;
      }
    });
    if (index > -1) {
      updatedBreadCrumbs = updatedBreadCrumbs.slice(0, index + 1);
    } else {
      updatedBreadCrumbs.push({
        path: action.data.path,
        name: action.data.path
          .split(encodeHandler("\\"))
          .slice(-1)
          .join("")
      });
    }
  }

  updatedEnumFolder.path = action.data.path;
  updatedEnumFolder.folders = action.data.folders ? action.data.folders : [];
  updatedEnumFolder.loading = false;
  updatedEnumFolder.breadCrumbs = updatedBreadCrumbs;
  updatedEnumFolder.customPathTemp = null;
  updatedEnumFolder.createFolderError = null;

  updatedEnumFolder.folders = updatedEnumFolder.folders.filter(v =>
    isDecodable(v.name, "Enum Folder listing - ")
  );

  return updateObject(state, {
    enumFolder: updateObject(state.enumFolder, updatedEnumFolder)
  });
}

function enumFolder(state, action) {
  // eslint-disable-next-line no-unused-vars
  let updatedBreadCrumbs = [];
  if (action.name) {
    updatedBreadCrumbs = { ...state.enumFolder.breadCrumbs };
    updatedBreadCrumbs = updatedBreadCrumbs.push[action.name];
  } else {
    updatedBreadCrumbs = [];
  }

  return updateObject(state, {
    clientUUID: action.clientUUID,
    enumFolder: updateObject(state.enumFolder, {
      loading: true,
      createFolderPop: false
    })
  });
}

function createFolder(state, action) {
  return updateObject(state, {
    enumFolder: updateObject(state.enumFolder, {
      loading: true
    })
  });
}

function createFolderResponse(state, action) {
  if (state.clientUUID !== action.clientUUID) return state;

  const updatedFolders = [...state.enumFolder.folders];
  let error = false;
  if (action.data.result === "success")
    updatedFolders.unshift({ name: action.data.name });
  else {
    error = true;
    if (action.data.reason === "Allready exist")
      action.data.reason = CONTENT.restore.file.alreadyExit;
  }

  return updateObject(state, {
    enumFolder: updateObject(state.enumFolder, {
      folders: updatedFolders,
      loading: false,
      createFolderPop: error,
      createFolderError: error ? action.data.reason : false
    })
  });
}

function createFolderPop(state, action) {
  return updateObject(state, {
    enumFolder: updateObject(state.enumFolder, {
      createFolderPop: action.bool
    })
  });
}

function selectCustomPath(state, action) {
  return updateObject(state, {
    enumFolder: updateObject(state.enumFolder, {
      customPathTemp:
        state.enumFolder.path === "alldrives"
          ? action.name
          : state.enumFolder.path + encodeHandler("\\") + action.name
    })
  });
}

function setRestoreLocation(state, action) {
  return updateObject(state, {
    isCustomRestore: action.location === "custom" ? true : false
  });
}

function confirmRestorePath(state, action) {
  //if (!state.enumFolder.customPathTemp && state.enumFolder.path === "alldrives") customPathTemp = null;
  return updateObject(state, {
    enumFolder: updateObject(state.enumFolder, {
      customPath: state.enumFolder.customPathTemp
        ? state.enumFolder.customPathTemp
        : !state.enumFolder.customPathTemp &&
          state.enumFolder.path === "alldrives"
        ? null
        : state.enumFolder.path
    })
  });
}

function changeFRTargetMachine(state, action) {
  if (!action.client) return state;
  return updateObject(state, {
    targetMachine: action.client
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_FR_RECOVERY_POINTS_START:
      return fetchFRRecoveryPointsStart(state, action);
    case types.FETCH_FR_RECOVERY_POINTS_SUCCESS:
      return fetchFRRecoveryPointsSuccess(state, action);
    case types.FETCH_FR_RECOVERY_POINTS_FAILURE:
      return fetchFRRecoveryPointsFailure(state, action);
    case types.UPDATE_FR_RECOVERY_POINT_SUCCESS:
      return updateFRRecoveryPointSuccess(state, action);
    case types.CHANGE_FR_RECOVERY_POINT:
      return changeFRRecoveryPoint(state, action);
    case types.FETCH_FILES_START:
      return fetchFilesStart(state, action);
    case types.FETCH_FILES_SUCCESS:
      return fetchFilesSuccess(state, action);
    case types.FETCH_FILES_FAILURE:
      return fetchFilesFailure(state, action);
    case types.PATTERN_SEARCH_START:
      return patternSearchStart(state, action);
    case types.TOGGLE_SELECT_ALL_FILES:
      return toggleSelectAllFiles(state, action);
    case types.TOGGLE_FILE_SELECTION:
      return toggleFileSelection(state, action);
    case types.TOGGLE_SHIFT_FILE_SELECTION:
      return toggleShiftFileSelection(state, action);
    case types.CHANGE_SEARCH:
      return changeSearch(state, action);
    case types.STORE_REQUEST_PARAMS:
      return storeRestoreParams(state, action);
    case types.CLEAR_FILE_RESTORE:
      return clearFileRestore();
    case types.DOWNLOAD_RESTORE_FILES_START:
      return downloadRestoreFilesStart(state, action);
    case types.REMOVE_RESTORE_URL_LOADER:
      return removeRestoreURLLoader(state, action);
    case types.DISABLE_RESTORE:
      return setDisableRestore(state, action);
    case types.ENUM_FOLDER_RESPONSE:
      return enumFolderResponse(state, action);
    case types.ENUM_FOLDER:
      return enumFolder(state, action);
    case types.CREATE_FOLDER:
      return createFolder(state, action);
    case types.CREATE_FOLDER_RESPONSE:
      return createFolderResponse(state, action);
    case types.CREATE_FOLDER_POP:
      return createFolderPop(state, action);
    case types.SELECT_CUSTOM_PATH:
      return selectCustomPath(state, action);
    case types.SET_RESTORE_LOCATION:
      return setRestoreLocation(state, action);
    case types.CONFIRM_CUSTOM_PATH:
      return confirmRestorePath(state, action);
    case types.CHANGE_FILE_RESTORE_TARGET_MACHINE:
      return changeFRTargetMachine(state, action);
    case types.POPULATE_UPDATED_VOLUMES_FR:
      return populateUpdatedVolumesFR(state, action);
    case types.FETCH_UPDATED_VOLUMES_FR:
      return fetchUpdatedVolumesFR(state, action);
    default:
      return state;
  }
}

export default reducer;
